import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedModel: null,
  defaultModel: null,
};

const aiModelSlice = createSlice({
  name: "aiModel",
  initialState,
  reducers: {
    setSelectedLLMModel: (state, action) => {
      state.selectedModel = action.payload;
    },
    setDefaultLLMModel: (state, action) => {
      state.defaultModel = action.payload;
      state.selectedModel = action.payload;
    },
    resetSelectedLLMModel: (state) => {
      state.selectedModel = null;
      state.defaultModel = null;
    },
  },
});

export const {
  setSelectedLLMModel,
  setDefaultLLMModel,
  resetSelectedLLMModel,
} = aiModelSlice.actions;

export default aiModelSlice.reducer;
